import CirgsHome from './CirgsHome';

export default CirgsHome;
